import { Card, Heading, Label, Pane, TickCircleIcon } from "evergreen-ui";
import React from "react";

const BankAccountDetails = ({ accountDetail }) => {
  if (!accountDetail) return <Pane />;

  return (
    <Pane maxWidth="33%" marginTop={20}>
      <Heading size={500} marginBottom={10}>
        Bank Account Connection
      </Heading>

      <Card backgroundColor="white" elevation={1} padding={10}>
        <Heading size={400}>{accountDetail.name}</Heading>
        <Pane display="flex" justifyContent="space-between">
          <Heading size={300}> **** **** {accountDetail.mask}</Heading>
        </Pane>
        <Label color="green" marginTop={15} display="flex">
          Connected{" "}
          <TickCircleIcon
            color="success"
            marginLeft={5}
            marginTop={3}
            display="inline-block"
          />
        </Label>
      </Card>
    </Pane>
  );
};

export default BankAccountDetails;
